import { render, staticRenderFns } from "./dangerMessage.vue?vue&type=template&id=c00ab45c&scoped=true&class=DangerMessage"
import script from "./dangerMessage.vue?vue&type=script&lang=js"
export * from "./dangerMessage.vue?vue&type=script&lang=js"
import style0 from "./dangerMessage.vue?vue&type=style&index=0&id=c00ab45c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c00ab45c",
  null
  
)

export default component.exports